export default __webpack_public_path__ + "static/media/usps.655afe2f.svg";